import type { Channel } from "@hybrid-iptv/types";

/**
 * The channel a TV-style start opens on (owner, 2026-10-12): the profile's most recently
 * watched live channel that is still there, else the guide's last channel, else none, which
 * opens the guide without playing anything.
 *
 * `channels` is every channel the profile may see (parental-locked categories already left
 * out by useChannels) minus hidden ones, so a locked, hidden or removed channel is skipped
 * here rather than tuned.
 */
export function pickStartChannel(input: {
  /** Recently watched channel ids, newest first. */
  recentIds: readonly string[];
  /** The guide's saved last channel for this profile. */
  lastChannelId: string | null;
  channels: readonly Channel[];
}): Channel | null {
  const byId = new Map(input.channels.map((channel) => [channel.id, channel]));
  for (const id of input.recentIds) {
    const channel = byId.get(id);
    if (channel) return channel;
  }
  return input.lastChannelId ? (byId.get(input.lastChannelId) ?? null) : null;
}
